var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.getClasses(), on: { click: _vm.showField } }, [
    _c("div", { staticClass: "field-header" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLabel,
              expression: "showLabel"
            }
          ],
          staticClass: "field-label"
        },
        [_vm._v(_vm._s(_vm.customField.label))]
      ),
      _vm._v(" "),
      _vm.customField.field_type == "wysiwyg" &&
      _vm.customField.updated_at &&
      _vm.updatedOnTop == true
        ? _c("div", { staticClass: "last-updated" }, [
            _vm._v(
              "\n      Last updated " +
                _vm._s(
                  _vm._f("moment")(_vm.customField.updated_at, "MMM D HH:mm a")
                ) +
                "\n    "
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.customField.field_type == "priority"
      ? _c("div", { staticClass: "field-wrap" }, [
          _c(
            "div",
            {
              staticClass: "priority-rating",
              on: {
                click: function($event) {
                  return _vm.setPriority(_vm.customField)
                }
              }
            },
            [
              _c("vue-star-rate", {
                key: "del-priority-" + Math.random() + _vm.deliverable.id,
                attrs: {
                  rateRange: _vm.customField.value
                    ? Number(_vm.customField.value)
                    : 0,
                  maxIcon: 5,
                  iconHeight: 17,
                  iconWidth: 17,
                  hasCounter: false,
                  iconColor: "var(--wf-primary)",
                  iconColorHover: "var(--wf-primary)",
                  iconShape: "circle"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "wysiwyg"
      ? _c(
          "div",
          { staticClass: "field-wrap" },
          [
            _c("ckeditor", {
              ref: "customInput",
              attrs: {
                readOnly:
                  !_vm.userAbilities.editMediaCall ||
                  _vm.deliverable.permissions.viewOnly,
                editorUrl: "/js/ckeditor/ckeditor.js",
                id: "custom-field-" + _vm._uid,
                config: _vm.editorConfig
              },
              on: {
                input: function($event) {
                  _vm.changed = true
                },
                blur: function($event) {
                  return _vm.checkChangedFieldValue(_vm.customField)
                },
                ready: function($event) {
                  _vm.changed = false
                }
              },
              model: {
                value: _vm.customField.value,
                callback: function($$v) {
                  _vm.$set(_vm.customField, "value", $$v)
                },
                expression: "customField.value"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "textarea"
      ? _c("div", { staticClass: "field-wrap" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editing,
                  expression: "!editing"
                },
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "exclude-outside-click field-value text-hover-bg",
              attrs: { title: _vm.customField.value }
            },
            [_vm._v(_vm._s(_vm.customField.value || "Click to set..."))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "custom-field" }, [
            _c("textarea", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editing,
                  expression: "editing"
                },
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.outside,
                  expression: "outside"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.customField.value,
                  expression: "customField.value"
                }
              ],
              ref: "customInput",
              staticClass: "form-control custom-inputs",
              attrs: { rows: _vm.rows },
              domProps: { value: _vm.customField.value },
              on: {
                change: function($event) {
                  return _vm.updateFieldValue(_vm.customField)
                },
                blur: function($event) {
                  _vm.editing = false
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.customField, "value", $event.target.value)
                }
              }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "select"
      ? _c("div", { staticClass: "field-wrap" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editing,
                  expression: "!editing"
                }
              ],
              staticClass: "exclude-outside-click field-value text-hover-bg"
            },
            [_vm._v(_vm._s(_vm.customField.value || "Click to set..."))]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "custom-field" },
            [
              _c("multiselect", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editing,
                    expression: "editing"
                  }
                ],
                ref: "customInput",
                attrs: {
                  "show-labels": false,
                  options: _vm.getOptions,
                  multiple: false
                },
                on: {
                  close: function($event) {
                    _vm.editing = false
                  },
                  input: function($event) {
                    _vm.updateFieldValue(_vm.customField)
                    _vm.editing = false
                  }
                },
                model: {
                  value: _vm.customField.value,
                  callback: function($$v) {
                    _vm.$set(_vm.customField, "value", $$v)
                  },
                  expression: "customField.value"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "status"
      ? _c("div", { staticClass: "field-wrap no-icon" }, [
          _vm.customField.value
            ? _c(
                "span",
                {
                  staticClass:
                    "exclude-outside-click field-value status-field-value",
                  style: {
                    backgroundColor:
                      _vm.parseValue(_vm.customField.value).color ||
                      _vm.customField.value.color
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.parseValue(_vm.customField.value).name ||
                        _vm.customField.value.name
                    )
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.customField.value
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editing,
                      expression: "!editing"
                    }
                  ],
                  staticClass: "exclude-outside-click field-value"
                },
                [_vm._v("Click to set...")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "custom-field status-field" },
            [
              _c("multiselect", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editing,
                    expression: "editing"
                  },
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  }
                ],
                ref: "customInput",
                attrs: {
                  searchable: false,
                  options: _vm.getOptions,
                  "custom-label": _vm.customLabel,
                  "show-labels": false
                },
                on: {
                  close: function($event) {
                    _vm.editing = false
                  },
                  input: function($event) {
                    return _vm.updateFieldValue(_vm.customField)
                  },
                  select: function($event) {
                    _vm.editing = false
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "option",
                      fn: function(props) {
                        return [
                          _c(
                            "div",
                            {
                              style: {
                                color: "var(--wf-secondary)",
                                borderRadius: "10px",
                                backgroundColor: props.option.color,
                                height: "40px",
                                lineHeight: "40px",
                                textAlign: "center"
                              }
                            },
                            [_vm._v(_vm._s(props.option.name))]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2413709391
                ),
                model: {
                  value: _vm.customField.value,
                  callback: function($$v) {
                    _vm.$set(_vm.customField, "value", $$v)
                  },
                  expression: "customField.value"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "users"
      ? _c("div", { staticClass: "field-wrap field-wrap-users no-icon" }, [
          _c("div", { staticClass: "field-value  exclude-outside-click" }, [
            _c("span", { staticClass: "info-bubbles" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass:
                    "exclude-outside-click field-value initials badge badge-primary",
                  staticStyle: { display: "inline-block" },
                  attrs: { title: _vm.customField.userName }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._f("textInitials")(
                          _vm.customField.userName || "Click to set..."
                        )
                      ) +
                      "\n      "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "add-multiselect-group" },
              [
                _c("plus-button"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editing,
                        expression: "editing"
                      }
                    ],
                    staticClass: "custom-field user-field custom-multiselect"
                  },
                  [
                    _c("multiselect", {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        }
                      ],
                      ref: "customInput",
                      attrs: {
                        options: _vm.allUsers,
                        "show-labels": false,
                        multiple: false,
                        "open-direction": "bottom",
                        label: "name",
                        "track-by": "id"
                      },
                      on: {
                        close: function($event) {
                          _vm.editing = false
                        },
                        input: function($event) {
                          _vm.updateFieldValue(_vm.customField)
                          _vm.editing = false
                        }
                      },
                      model: {
                        value: _vm.selectedUser,
                        callback: function($$v) {
                          _vm.selectedUser = $$v
                        },
                        expression: "selectedUser"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "datepicker"
      ? _c("div", { staticClass: "field-wrap" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editing,
                  expression: "!editing"
                }
              ],
              staticClass: "exclude-outside-click field-value text-hover-bg"
            },
            [
              _vm._v(
                _vm._s(
                  _vm._f("moment")(
                    _vm.customField.value || new Date(),
                    "DD MMM, YYYY"
                  )
                )
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "custom-field" },
            [
              _c("vuejs-datepicker", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.outside,
                    expression: "outside"
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editing,
                    expression: "editing"
                  }
                ],
                ref: "customDatepicker",
                attrs: {
                  format: _vm.customDateFormat,
                  name: "due_date",
                  "input-class": "custom-datepicker form-control",
                  typeable: true
                },
                on: {
                  input: function($event) {
                    return _vm.updateFieldValue(_vm.customField)
                  },
                  selected: function($event) {
                    _vm.dateSelected = true
                  }
                },
                model: {
                  value: _vm.customField.value,
                  callback: function($$v) {
                    _vm.$set(_vm.customField, "value", $$v)
                  },
                  expression: "customField.value"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "file"
      ? _c("span", [_c("input", { attrs: { type: "file" } })])
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "radio"
      ? _c(
          "span",
          _vm._l(_vm.parseValue(_vm.customField.value_set), function(
            radioValue,
            index
          ) {
            return _c("label", { key: "radio" + index, staticClass: "ml-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.customField.value,
                    expression: "customField.value"
                  }
                ],
                attrs: { type: "radio" },
                domProps: {
                  value: radioValue,
                  checked: _vm._q(_vm.customField.value, radioValue)
                },
                on: {
                  change: [
                    function($event) {
                      return _vm.$set(_vm.customField, "value", radioValue)
                    },
                    function($event) {
                      return _vm.updateFieldValue(_vm.customField)
                    }
                  ]
                }
              }),
              _vm._v("\n      " + _vm._s(radioValue) + "\n    ")
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.customField.field_type == "wysiwyg" &&
    _vm.customField.updated_at &&
    _vm.updatedOnTop == false
      ? _c("div", { staticClass: "last-updated last-updated-below" }, [
          _vm._v(
            "\n    Last updated " +
              _vm._s(
                _vm._f("moment")(_vm.customField.updated_at, "MMM D HH:mm a")
              ) +
              "\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }